import {BibEmprestimoModel} from '@/models/biblioteca/bibemprestimo/bibemprestimo.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import {RegisterOutput} from '@/models/register-output';

class BibEmprestimoService {
 dadosIndexPaginado(
  pagina: number,
  itensPorPagina: number,
  filters: FiltrosModel[],
  bibTipoUsuarioId: number,
  segUsuarioId: number,
  gesEscolaId: number
 ): Promise<AxiosResponse<DataSource<BibEmprestimoModel>>> {
  return api.post <DataSource <BibEmprestimoModel>>('/BibEmprestimo/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  }, {
   params: {
    BibTipoUsuarioId: bibTipoUsuarioId,
    SegUsuarioId: segUsuarioId,
    GesEscolaId: gesEscolaId,
   }
  });
 }

 inserirAtualizar(bibEmprestimo: BibEmprestimoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibEmprestimo', bibEmprestimo);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibEmprestimo/' + id);
 }

 atualizar(bibEmprestimo: BibEmprestimoModel): Promise<AxiosResponse> {
  return api.post('/BibEmprestimo', bibEmprestimo);
 }

 async get(id: number): Promise<BibEmprestimoModel> {
  const result = await api.get<BibEmprestimoModel>(`/BibEmprestimo/${id.toString()}`);
  return result.data;
 }
}
export default new BibEmprestimoService();
